// App-level configuration.
//
// DONATE_URL: paste your donation link here (Ko-fi, Buy Me a Coffee, Donorbox,
// PayPal.me, or a Stripe Payment Link). Leave empty ("") until you have one —
// the Support button will show a gentle "coming soon" message.
// Using an external link that opens in the browser keeps donations compliant
// on the web, Android, and (later) the Apple App Store.
export const DONATE_URL = "";

export const MINISTRY_NAME = "Not By Will";

// Contact email shown on the Privacy Policy and Terms pages. Update to your
// preferred inbox (e.g., privacy@notbywill.com).
export const CONTACT_EMAIL = "support@notbywill.com";
